// Voice authority is issued by Backend, never inferred from reply text or dates.
// This association prevents the portal from accidentally moving a receipt to a
// different reply. Backend still authenticates every receipt and exact text.
const originatingText = new WeakMap();
const attemptedReceipts = new Set();
export const VOICE_AUTHORITY_REFUSED = "VOICE_AUTHORITY_REFUSED";

export function normalizeSpeechAuthorization(raw, text) {
  if (!raw || typeof raw !== "object" || Array.isArray(raw) || raw.version !== 1 ||
      !["NON_REPORTING", "REPORT_DERIVED", "WITHHELD"].includes(raw.classification) ||
      typeof raw.browserFallbackAllowed !== "boolean" ||
      !(raw.receipt === null || (typeof raw.receipt === "string" && raw.receipt.length > 0 && raw.receipt.length <= 16384))) return null;
  const authorization = Object.freeze({
    version: 1,
    classification: raw.classification,
    receipt: raw.receipt,
    browserFallbackAllowed: raw.browserFallbackAllowed,
  });
  originatingText.set(authorization, String(text || "").trim());
  return authorization;
}

export function claimSpeechAuthorization(authorization, text) {
  if (!authorization || originatingText.get(authorization) !== String(text || "").trim() ||
      authorization.classification !== "NON_REPORTING" || !authorization.receipt ||
      authorization.browserFallbackAllowed !== true) return false;
  if (attemptedReceipts.has(authorization.receipt)) return false;
  // No automatic retry after a timeout/disconnect or component remount. A new
  // authoritative response has a new receipt; report audio remains withheld.
  attemptedReceipts.add(authorization.receipt);
  return true;
}

export function voiceAuthorityRefusal(reason = "speech_authority_missing_or_ineligible") {
  return { ok: false, reason, code: VOICE_AUTHORITY_REFUSED,
    governanceRefused: true, browserFallbackAllowed: false, provider: "none", audio: null };
}

export function isVoiceGovernanceRefusal(response, body) {
  return response?.status === 401 || response?.status === 403 || response?.status === 409 ||
    body?.code === VOICE_AUTHORITY_REFUSED || body?.browserFallbackAllowed === false;
}

export function admittedBrowserFallback(body) {
  return body?.classification === "NON_REPORTING" && body?.browserFallbackAllowed === true;
}
